/* ============================================================
   ÉTAPE 10: WORKFLOW & DEVIS (Refactorisée)
   ============================================================ */

import { CheckCircle, Clock, Info } from 'lucide-react';
import { useState } from 'react';
import { Card } from '../../../ui/card';
import { Label } from '../../../ui/label';
import { WorkflowTypeSelector } from '../WorkflowTypeSelector';
import { UrgentQuoteConfig } from '../UrgentQuoteConfig';

interface Step10WorkflowProps {
  data: any;
  onChange: (updates: any) => void;
  onSave?: () => void;
}

type WorkflowType = 'APPLICATION_REQUIRED' | 'IMMEDIATE' | 'QUOTE_REQUIRED';

export function Step10Workflow({ data, onChange }: Step10WorkflowProps) {
  const workflow: WorkflowType = data.workflow || 'QUOTE_REQUIRED';
  const [enableUrgent, setEnableUrgent] = useState(data.urgentQuotePrice !== null);

  const handleUrgentToggle = (enabled: boolean) => {
    setEnableUrgent(enabled);
    onChange({ urgentQuotePrice: enabled ? 20000 : null, urgentQuoteDelayHours: 24 });
  };

  return (
    <div className="space-y-6">
      <Card className="p-6 bg-[rgba(0,117,141,0.05)] border-[rgba(0,117,141,0.2)]">
        <div className="flex items-start gap-3">
          <Info className="w-6 h-6 text-[#00758d]" />
          <div><h4 className="font-semibold text-[#00303c] mb-2">Configuration du workflow</h4><p className="text-sm text-[#005a6d]">Définissez comment les réservations sont traitées.</p></div>
        </div>
      </Card>

      <WorkflowTypeSelector current={workflow} onSelect={(v) => onChange({ workflow: v })} />

      {workflow === 'QUOTE_REQUIRED' && (
        <div className="space-y-6 border-t pt-6">
          <h3 className="text-lg font-semibold">Configuration du devis</h3>
          <Card className="p-4 bg-gray-50 flex items-center gap-3"><Clock className="w-5 h-5 text-gray-600" /><div><p className="text-sm font-medium">Délai standard : 48 heures</p></div></Card>
          
          <UrgentQuoteConfig 
            enabled={enableUrgent} onToggle={handleUrgentToggle} 
            price={data.urgentQuotePrice} onPriceChange={(v) => onChange({ urgentQuotePrice: v })} 
            delay={data.urgentQuoteDelayHours || 24} onDelayChange={(v) => onChange({ urgentQuoteDelayHours: v })} 
          />

          <div>
            <Label htmlFor="quoteRules">Règles et conditions du devis (optionnel)</Label>
            <textarea id="quoteRules" value={data.quoteRules || ''} onChange={(e) => onChange({ quoteRules: e.target.value })} rows={5} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#00758d] focus:border-[#00758d] mt-2" placeholder="Ex: Le devis est valable 7 jours..." />
          </div>
        </div>
      )}

      <Card className="p-4 bg-[rgba(0,117,141,0.05)] border-[rgba(0,117,141,0.2)]">
        <div className="flex items-start gap-3">
          <CheckCircle className="w-6 h-6 text-[#00758d]" />
          <div><h4 className="font-semibold text-[#00303c] mb-1">Résumé</h4><p className="text-sm text-[#005a6d]">
            {workflow === 'APPLICATION_REQUIRED' && 'Validation manuelle requise.'}
            {workflow === 'QUOTE_REQUIRED' && (enableUrgent ? `Délai urgent : ${data.urgentQuoteDelayHours}h.` : 'Devis sous 48h.')}
            {workflow === 'IMMEDIATE' && 'Paiement immédiat activé.'}
          </p></div>
        </div>
      </Card>
    </div>
  );
}
